var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_632_25917)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 28,
    fill: "#3B3D4B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6875 30.0006C40.6883 32.3202 39.8926 34.5697 38.4336 36.3729C36.9745 38.1761 34.9406 39.4237 32.6719 39.9069C30.4032 40.3902 28.0374 40.0798 25.9701 39.0277C23.9029 37.9757 22.2596 36.2457 21.315 34.1271L18.1853 35.3984C19.426 38.2412 21.6076 40.5701 24.3633 41.9937C27.1191 43.4172 30.281 43.8486 33.3174 43.2152C36.3537 42.5818 39.0795 40.9224 41.0363 38.5158C42.9932 36.1093 44.0618 33.1024 44.0625 30.0006C44.0626 27.183 43.1812 24.436 41.5416 22.1445C39.9021 19.8531 37.5867 18.132 34.9199 17.2226C32.2531 16.3131 29.3686 16.2609 26.6706 17.0732C23.9726 17.8854 21.5964 19.5215 19.875 21.7521V17.6256H16.5V26.6256L18.1875 28.3131H26.0625V24.9381H21.792C22.906 23.0069 24.6263 21.4973 26.6859 20.6437C28.7455 19.7901 31.0292 19.6401 33.1828 20.2171C35.3363 20.7941 37.2392 22.0657 38.5962 23.8347C39.9531 25.6037 40.6883 27.7711 40.6875 30.0006Z",
    fill: "#BEDFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_632_25917",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_632_25917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_632_25917",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshButton);
export default __webpack_public_path__ + "static/media/RefreshButton.c71ed814fab581e39e6b3565250e3767.svg";
export { ForwardRef as ReactComponent };